import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import '@angular/localize/init';

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));

(window as any).__webpack_init_sharing__ = (name: string) => {
  if (!(window as any).__webpack_share_scopes__) {
    (window as any).__webpack_share_scopes__ = {};
  }
  if (!(window as any).__webpack_share_scopes__[name]) {
    (window as any).__webpack_share_scopes__[name] = {};
  }
  return Promise.resolve();
};
if (!(window as any).__webpack_share_scopes__) {
  (window as any).__webpack_share_scopes__ = { default: {} };
}
